/**
 * Factory for creating SessionService instances based on platform
 */

import { container } from 'tsyringe';
import SessionServiceNative from './SessionServiceNative';
import SessionServiceWeb from './SessionServiceWeb';
import ISessionService from './ISessionService';

/**
 * Parameters for creating SessionService strategies
 */
export interface ISessionServiceFactoryParams {
  isNative: boolean;
}

/**
 * Factory Pattern to encapsulate SessionService creation logic
 */
export class SessionServiceFactory {
  /**
   * Creates the appropriate SessionService based on the platform
   */
  static createService(params: ISessionServiceFactoryParams): ISessionService {
    const { isNative } = params;

    if (isNative) {
      return container.resolve(SessionServiceNative);
    } else {
      return container.resolve(SessionServiceWeb);
    }
  }

  /**
   * Returns available service types
   */
  static getAvailableServices(): string[] {
    return ['SessionServiceNative', 'SessionServiceWeb'];
  }
}
